<template>
  <section class="block portal client-portal" id="app">
    <div class="portal__wrapper">
      <div class="portal__header">
        <h1 class="portal__title title--l">{{ getUiString(['general','welcome_title']) }}{{ name }},</h1>
        <h2 class="portal__title title--l">{{ getUiString(['general','subtitle']) }}</h2>
        <div class="tabs" id="nav">
          <div class="tabs__tab" :class="{ 'tabs__tab--active': activeTab === 'claims' }">
            <span class="tabs__text">
              <span>{{ getUiString(['general', 'my_claims']) }}</span>
              <router-link class="container-link" to="/home/claims"></router-link>
            </span>
          </div>
           <div class="tabs__tab" v-if="hasManagedClaims" :class="{ 'tabs__tab--active': activeTab === 'managedclaims' }">
            <span class="tabs__text">
              <span>{{ getUiString(['general', 'my_managed_claims']) }}</span>
              <router-link class="container-link" to="/home/managedclaims"></router-link>
            </span>
          </div>
         <div class="tabs__tab" :class="{ 'tabs__tab--active': activeTab === 'account' }">
            <span class="tabs__text">
              <span>{{ getUiString(['general', 'my_account']) }}</span>
              <router-link class="container-link" to="/home/account"></router-link>
            </span>
          </div>
        </div>
      </div>
      <router-view/>
    </div>
    <slot></slot>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  name: 'HomeView',
  data () {
    return {
      name: this.$store.state.account.FirstName !== null && this.$store.state.account.FirstName !== undefined && this.$store.state.account.FirstName !== ''
        ? ' ' + this.$store.state.account.FirstName
        : '',
      activeTab: 'claims'
    }
  },
  computed: {
    ...mapGetters({
      getUiString: 'uistrings/getUiString',
      hasManagedClaims: 'dossier/hasManagedClaims'
    })
  },
  mounted () {
    if (this.$route.name !== 'claims') {
      this.$router.push('/home/claims')
    }
  },
  watch: {
    $route (to, from) {
      this.activeTab = to.name
    }
  }
}
</script>
